export default "__VITE_ASSET__D2SoV9f___"